import { useState, useContext, createContext, ReactNode, useEffect, useCallback } from 'react';
import { getAdminSystemInfo } from 'services/logo';
import { setAppTimezone } from 'utils/dateFormat';

type SystemInfo = {
  logoUrl: string;
  timezone?: string;
};

type SystemInfoContextType = {
  systemInfo: SystemInfo | null;
  setSystemInfo: (value: SystemInfo | null) => void;
};

const SystemInfoContext = createContext<SystemInfoContextType>({
  systemInfo: null,
  setSystemInfo: () => null
});

/**
 * @return useContext use context systemInfo
 */
export function useSystemInfo(): SystemInfoContextType {
  return useContext(SystemInfoContext);
}

type Props = {
  children: ReactNode;
};

/**
 * @return SystemInfoProvider provider value systemInfo
 */
export function SystemInfoProvider({ children }: Props) {
  const [systemInfo, setSystemInfo] = useState<SystemInfo | null>(null);
  const value = { systemInfo, setSystemInfo };

  const getSystemInfo = useCallback(async () => {
    const { logoUrl, timezone } = await getAdminSystemInfo();
    if (timezone) {
      setAppTimezone(timezone);
    }
    setSystemInfo({ logoUrl, timezone });
  }, []);

  useEffect(() => {
    getSystemInfo();
  }, [getSystemInfo]);

  return <SystemInfoContext.Provider value={value}>{children}</SystemInfoContext.Provider>;
}
